// Une couleur par « famille » d'itérations : CHF 1, CHF 2 et CHF 3 se suivent dans la même teinte.

const PALETTE = [
  { dot: 'bg-sky-500', soft: 'bg-sky-100', fill: 'bg-sky-400', strong: 'bg-sky-500', text: 'text-sky-800', ring: 'ring-sky-500', line: 'border-sky-300' },
  { dot: 'bg-violet-500', soft: 'bg-violet-100', fill: 'bg-violet-400', strong: 'bg-violet-500', text: 'text-violet-800', ring: 'ring-violet-500', line: 'border-violet-300' },
  { dot: 'bg-emerald-500', soft: 'bg-emerald-100', fill: 'bg-emerald-400', strong: 'bg-emerald-500', text: 'text-emerald-800', ring: 'ring-emerald-500', line: 'border-emerald-300' },
  { dot: 'bg-amber-500', soft: 'bg-amber-100', fill: 'bg-amber-400', strong: 'bg-amber-500', text: 'text-amber-800', ring: 'ring-amber-500', line: 'border-amber-300' },
  { dot: 'bg-rose-500', soft: 'bg-rose-100', fill: 'bg-rose-400', strong: 'bg-rose-500', text: 'text-rose-800', ring: 'ring-rose-500', line: 'border-rose-300' },
  { dot: 'bg-teal-500', soft: 'bg-teal-100', fill: 'bg-teal-400', strong: 'bg-teal-500', text: 'text-teal-800', ring: 'ring-teal-500', line: 'border-teal-300' },
  { dot: 'bg-indigo-500', soft: 'bg-indigo-100', fill: 'bg-indigo-400', strong: 'bg-indigo-500', text: 'text-indigo-800', ring: 'ring-indigo-500', line: 'border-indigo-300' },
  { dot: 'bg-orange-500', soft: 'bg-orange-100', fill: 'bg-orange-400', strong: 'bg-orange-500', text: 'text-orange-800', ring: 'ring-orange-500', line: 'border-orange-300' },
];

export const familyOf = (name) => String(name || '').replace(/[\s._-]*\d+([.,]\d+)*\s*$/, '').trim().toLowerCase();

export const iterationColors = (iterations = []) => {
  const families = [];
  const colors = new Map();
  iterations.forEach((iteration) => {
    const family = familyOf(iteration.name) || `#${iteration.id}`;
    if (!families.includes(family)) families.push(family);
    colors.set(iteration.id, PALETTE[families.indexOf(family) % PALETTE.length]);
  });
  return colors;
};

export const NEUTRAL = PALETTE[0];

/** « Sprint CHF 2.3 » → « 2.3 » ; sinon « S3 ». */
export const sprintShort = (sprint, index) => {
  const match = String(sprint?.name || sprint?.description || '').match(/(\d+[.,]\d+)\s*$/);
  return match ? match[1].replace(',', '.') : `S${index + 1}`;
};

export const sprintProgress = (sprint) => {
  const total = Number(sprint?.total_tokens) || 0;
  return total > 0 ? Math.min(1, (Number(sprint.tokens_completed) || 0) / total) : 0;
};

export const iterationProgress = (iteration) => {
  const total = Number(iteration?.total_tokens) || 0;
  return total > 0 ? Math.min(1, (Number(iteration.completed_tokens) || 0) / total) : 0;
};
